import { ReactNode, RefObject } from 'react'
import 'swiper/css'
import 'swiper/css/a11y'
import 'swiper/css/autoplay'
import { A11y, Autoplay } from 'swiper/modules'
import { Swiper, SwiperRef, SwiperSlide } from 'swiper/react'

import { SliderNextButton, SliderPrevButton } from '@/shared/ui/SliderButtons'

import cl from './SwiperSlider.module.scss'

const DEFAULT_DELAY = 8000

interface SwiperSliderProps {
	slides: ReactNode[]
	onSlideChange?: (index: number) => void
	ref?: RefObject<SwiperRef>
	autoplay?: boolean
	delay?: number
	pauseOnMouseEnter?: boolean
	isNavigationHidden?: boolean
}

export const SwiperSlider = (props: SwiperSliderProps) => {
	const {
		ref,
		onSlideChange,
		slides,
		autoplay = true,
		delay = DEFAULT_DELAY,
		pauseOnMouseEnter = true,
		isNavigationHidden = false
	} = props

	const autoplayConfig = autoplay
		? {
				delay,
				pauseOnMouseEnter,
				disableOnInteraction: false
		  }
		: false

	return (
		<Swiper
			ref={ref}
			className={cl.slider}
			spaceBetween={0}
			slidesPerView={1}
			loop={true}
			modules={[A11y, Autoplay]}
			autoplay={autoplayConfig}>
			{slides.map((item, index) => (
				<SwiperSlide key={index} className={cl.slide}>
					{props => {
						if (props.isActive) {
							onSlideChange?.(index)
						}

						return item
					}}
				</SwiperSlide>
			))}

			{!isNavigationHidden && (
				<div className={cl.buttons}>
					<SliderPrevButton className={cl.buttons__prevButton} />
					<SliderNextButton className={cl.buttons__nextButton} />
				</div>
			)}
		</Swiper>
	)
}
